var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkExternal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0999 1H10.0999C9.60289 1 9.19995 1.40294 9.19995 1.9C9.19995 2.39706 9.60289 2.8 10.0999 2.8H11.9299L8.35995 6.36C8.00648 6.71346 8.00648 7.28654 8.35995 7.64C8.71341 7.99346 9.28648 7.99346 9.63995 7.64L13.2999 4V6C13.2999 6.49706 13.7029 6.9 14.1999 6.9C14.697 6.9 15.0999 6.49706 15.0999 6V1Z",
    fill: "#2A6EBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9 15H11.1C12.1493 15 13 14.1493 13 13.1V10.59C13 10.0929 12.5971 9.69 12.1 9.69C11.6029 9.69 11.2 10.0929 11.2 10.59V13.1C11.2 13.1552 11.1552 13.2 11.1 13.2H2.9C2.84477 13.2 2.8 13.1552 2.8 13.1V4.9C2.8 4.84477 2.84477 4.8 2.9 4.8H5.33C5.82706 4.8 6.23 4.39706 6.23 3.9C6.23 3.40294 5.82706 3 5.33 3H2.9C1.85066 3 1 3.85066 1 4.9V13.1C1 14.1493 1.85066 15 2.9 15Z",
    fill: "#2A6EBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExternal);
export default __webpack_public_path__ + "static/media/link-external.5fcc9788048c0019b1353cf925f60c90.svg";
export { ForwardRef as ReactComponent };